// extracted by mini-css-extract-plugin
export default {"info":"styles_info__X6GTw","avatar":"styles_avatar__fxx9y"};